"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.buildClickHandler = exports.displayNoEvidenceAvailable = exports.externalSource = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var CaseArtifactTypes = ui_common_1.commonEnums.CaseArtifactTypes;
var externalSource = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CODED,
    CaseArtifactTypes.CLAIM
].map(function (code) { return code.toLowerCase(); }));
exports.externalSource = externalSource;
var displayNoEvidenceAvailable = function (artifact) {
    var _a;
    var text = '';
    if (((_a = artifact.meta) === null || _a === void 0 ? void 0 : _a.imported) === true) {
        text = 'This code was billed on a different case';
    }
    else {
        text = externalSource.has(artifact.type.toLowerCase())
            ? "This code originated in your health system."
            : "There is no displayable evidence at this time.";
    }
    return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "case-evidence-list" }, { children: (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "qa-empty-message" }, { children: text })) }) })));
};
exports.displayNoEvidenceAvailable = displayNoEvidenceAvailable;
var buildClickHandler = function (onSelection, evidence) {
    return function (ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('span');
        var valuable = target.classList.contains('field-value');
        var linkable = target.closest('.case-evidence-item.case-evidence-linked');
        if (!valuable || !linkable)
            return;
        var item = target.attributes.getNamedItem('data-index');
        if (!item)
            return;
        var currentIndex = parseInt(item.value);
        var feature = evidence[currentIndex];
        var display = !linkable.classList.contains('case-evidence-active');
        onSelection({
            evidence: feature,
            display: display
        });
    };
};
exports.buildClickHandler = buildClickHandler;
//# sourceMappingURL=case-evidence-common.js.map